export default[
	{
		path: '*',
		name: '404',
		component: () => import('@/Modules/ErrorPage/Views/404.vue'),
		meta : {
			title : '404 Page Not Found'
		}
	},
	{
		path: '/no-permission',
		name: '403',
		component: () => import('@/Modules/ErrorPage/Views/403.vue'),
		meta : {
			title : '403 No permission'
		}
	},
]
